module.exports = __webpack_public_path__ + "media/assets/partners/jourdeness-922016387d023cb63f034531812bf237.svg";